document.addEventListener("DOMContentLoaded", function () {
  const headerHamburger = document.querySelector(".header-hamburger");
  const closeImg = document.querySelector(".hamberger-close-img");
  const mobHeader = document.getElementById("mob-header");
  const htmlElement = document.documentElement; // Reference to the <html> tag

  headerHamburger.addEventListener("click", function () {
    mobHeader.classList.add("mob-header-active");
    htmlElement.classList.add("html-active");
  });

  closeImg.addEventListener("click", function () {
    mobHeader.classList.remove("mob-header-active");
    htmlElement.classList.remove("html-active");
  });
});


$(document).ready(function(){
    $('.single-item').slick({
      dots: true,             
      infinite: true,         
      speed: 500,             
      slidesToShow: 1,        
      slidesToScroll: 1,      
      autoplay: true,         
      autoplaySpeed: 4000,    
      arrows: false            
    });
  });



var swiper = new Swiper(".st-mltoys-hero", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
  
 var mySwiper = new Swiper(".st-shows-us-your-ride-swiper", {
  loop: true,
  slidesPerView: 3,
  centeredSlides: true,
  effect: "coverflow",
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 4,
    slideShadows: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    9992: {
      slidesPerView: 2, // Show 2 slides for screens 9992px or smaller
    },
  },
});



// video play btn
document.addEventListener('DOMContentLoaded', function () {
    const videoFrame = document.getElementById('youtube-video');
    const playButton = document.getElementById('play-btn');
    
    let player;
    let isPlaying = false;
  
    // Load the YouTube Iframe API script
    const script = document.createElement('script');
    script.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(script);
  
    // Create the player when the API is ready
    window.onYouTubeIframeAPIReady = function () {
        player = new YT.Player('youtube-video', {
            events: {
                'onStateChange': onPlayerStateChange
            }
        });
    };
  
    // Handle state change events (play/pause)
    function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
            isPlaying = true;
            playButton.style.display = 'none'; // Hide the play button when playing
        } else if (event.data === YT.PlayerState.PAUSED) {
            isPlaying = false;
            playButton.style.display = 'block'; // Show the play button when paused
        }
    }
  
    // Play button click event
    playButton.addEventListener('click', function () {
        if (isPlaying) {
            player.pauseVideo(); // Pause the video
        } else {
            player.playVideo(); // Play the video
        }
    });
  
    // Video frame click event (toggle playback)
    videoFrame.addEventListener('click', function () {
        if (isPlaying) {
            player.pauseVideo(); // Pause the video
        } else {
            player.playVideo(); // Play the video
        }
    });
  });


  document.querySelectorAll('.toggle-arrow').forEach((arrow) => {
    arrow.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent event bubbling
        const submenu = arrow.nextElementSibling; // Find the associated submenu
        if (submenu && submenu.classList.contains('mob-inner-submenu')) {
            submenu.classList.toggle('toggle-menu'); // Toggle submenu visibility
            arrow.classList.toggle('rotate-arrow'); // Rotate arrow
        }
    });
});

 // Wait for the DOM to load
  document.addEventListener('DOMContentLoaded', function() {
    // Select the image and the announcement bar
    const crossImg = document.querySelector('.bar-cross-img');
    const announcementBar = document.querySelector('.announcement-bar');

    // Add a click event listener to the image
    crossImg.addEventListener('click', function() {
      announcementBar.classList.add('close-top-bar'); // Replace 'new-class' with your desired class name
    });
  });



